export default "/_next/static/chunks/fonts/FontAwesome-1e59d2330b4c6deb84b340635ed36249.ttf";